import { OrganisationFeatureFlags } from '../../models/organisation';
/**
 * bundleRequired: Twilio needs an approved regulatory bundle before it sells a local number there. Twilio's Regulations
 * API also lists entries for US and CA, but purchase does not need them, so this flag decides, not the API.
 */
export const PHONE_NUMBER_COUNTRIES = [
    { code: `NZ`, name: `New Zealand`, areaCodeSearch: false, bundleRequired: true },
    { code: `AU`, name: `Australia`, areaCodeSearch: false, bundleRequired: true },
    { code: `GB`, name: `United Kingdom`, areaCodeSearch: false, bundleRequired: true },
    { code: `US`, name: `United States`, areaCodeSearch: true, bundleRequired: false },
    { code: `CA`, name: `Canada`, areaCodeSearch: true, bundleRequired: false },
];
/**
 * Countries click to call may buy numbers in and dial. US is held back behind the US_CALLING flag until the US wave:
 * all-party recording states and CIPA vendor claims need legal review first (#6700). Anywhere else is not dialled.
 */
export function callingCountryAllowed(isoCountry, featureFlags) {
    if (isoCountry === `US`)
        return featureFlags.includes(OrganisationFeatureFlags.US_CALLING);
    return isoCountry === `NZ` || isoCountry === `AU` || isoCountry === `GB` || isoCountry === `CA`;
}
//# sourceMappingURL=phoneNumbers.js.map